var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items?.length > 0)?_c('BaseTableView',{attrs:{"head":_vm.tableHead,"list-view":"mdAndUp"}},[_vm._l((_vm.items),function(item,key){return [_c('SalaryTableItems',{key:key,attrs:{"item":item,"edit":_vm.edit}})]})],2):_c('Plug')
}
var staticRenderFns = []

export { render, staticRenderFns }